<div id="bank-accounts-wrapper" class="divWhiteBackground">
  <form novalidate="" id="cac-accounts-details-form" class="formStyle">
    <div id="cac-banking-div-header" class="form-group">
      <h2 id="cac-banking-tellus-h2" class="h2-black center">
        {{ globalText?.accounts?.title }}
      </h2>
      <div id="cac-banking-desc-span" class="body-black center">
        {{ globalText?.accounts?.subTitle }}
      </div>
    </div>
    <div id="cac-banking-div-error" class="form-group center pt-58">
      <div
        *ngFor="let type of accountTypes"
        (click)="toggleAccount(type.id)"
        (onfocus)="mouseOver(type.id)"
        (keydown.space)="toggleAccount(type.id)"
        (keydown.enter)="toggleAccount(type.id)"
        (mouseover)="mouseOver(type.id)"
        (mouseout)="mouseOut(type.id)"
        class="custom-column-full custom-display-inline col-md-4 divblock"
      >
        <div
          tabindex="0"
          [ngClass]="[
            type.isSelected ? 'divBanking divSelected' : 'divBanking',
            type.isOnMouse ? 'divMouseEntered' : 'divMouseExit'
          ]"
          id="cac-banking-divBox-{{ type.id }}"
        >
          <div class="divBoxIcon divBox1Icon">
            <img
              alt="{{ type.displayName }}"
              src="{{ type.src }}"
              [ngClass]="type.id === 2 ? 'img-tranformation accImg' : 'accImg'"
            />
          </div>
          <div class="divBoxText form-field-black-acc">
            {{ type.displayName }}
          </div>
        </div>
      </div>
    </div>
    <div class="form-group center pb-30">
      <div
        class="custom-column-full custom-display-inline col-md-16 divBoxTextCenter"
      >
        <input
          type="checkbox"
          id="cac-banking-noneId"
          [(ngModel)]="nonBanking"
          [ngModelOptions]="{ standalone: true }"
          (change)="handleNonBankingCheckboxToggle(nonBanking)"
          (keydown.enter)="handleEnterKeyPress($event)"
          name="cac-banking-noneId"
        />
        <label
          for="cac-banking-noneId"
          class="form-field-black-acc grey-text pointer"
          >&nbsp;&nbsp;{{ formFieldData?.nonBanking?.label }}</label
        >
        <div *ngIf="noSelection">
          <div class="error-label">
            {{ formFieldData?.nonBanking?.errors?.acce1 }}
          </div>
        </div>
        <div class="error-spacer"></div>
      </div>
    </div>
  </form>
</div>
